import { ModulePlaceholder } from "@/components/modules/ModulePlaceholder";

const Gov = () => {
  return <ModulePlaceholder moduleKey="gov" />;
};

export default Gov;
